import { render, staticRenderFns } from "./404.vue?vue&type=template&id=74ee5d2c&scoped=true&"
var script = {}
import style0 from "./404.vue?vue&type=style&index=0&id=74ee5d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74ee5d2c",
  null
  
)

export default component.exports